module.exports = __webpack_public_path__ + "static/media/tool_logo_w3af.221ef0f2.png";